import { getAnalytics, logEvent } from 'firebase/analytics';
import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from '../../../../navigation';
import { useNavigate } from '../../../../navigation';
import { affiliateProductsApi } from '../../../../api/affiliate_products';
import { setMenu } from '../../../../features/restaurant/restaurant';
import { AffiliateProduct } from '../../../../interfaces/affiliate_products';
import { TTMenu } from '../../../../interfaces/menus';
import { RootState } from '../../../../rootReducer';
import { BUSINESS_TYPES, BUSINESS_TYPES_DICT } from '../../../../utils';
import { isMenuAvailable, toSentenceCase } from '../../../utils';
import AffiliateProductCard from './AffiliateProductCard';
import MenuCard from './MenuCard';
import TrackingContext from '../../../Providers/TrackingContext';
import { useAppDispatch } from '../../../../store';
import { menuUrl } from '../../../../env';

type Props = {};

export function CategorizedMenuView() {
  const menus = useSelector<RootState, TTMenu[]>(
    state => state.restaurant.current_menus,
  );

  const { trackFBEvent, trackGAEvent } = useContext(TrackingContext);

  const [affiliateProducts, setAffiliateProducts] = useState<{
    [key: string]: AffiliateProduct[];
  }>({});
  const [categorizedView, setCategorizedView] = useState<{
    [key: string]: TTMenu[];
  }>({});
  const qr_code_menu_ids = useSelector<RootState, { [key: string]: number[] }>(
    state => state.cart.qr_code_menu_ids,
  );
  const { r_id } = useParams();
  const qr = useSelector<RootState, string>(state => state.cart.qr_code);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const fetchAffiliateProducts = async () => {
    try {
      const response = await affiliateProductsApi.getMerchantProducts(
        parseInt(r_id),
      );
      let new_values: { [key: string]: AffiliateProduct[] } = {};
      let tags = Array.from(
        new Set(
          response.data
            ?.map(p => p.tags ?? [])
            ?.reduce((a, b) => a.concat(b), []),
        ),
      ); // O(n)
      tags.forEach(t => {
        response.data?.forEach(p => {
          if (p.tags.indexOf(t) !== -1) {
            if (new_values[t]) {
              new_values[t]?.push(p);
            } else {
              new_values[t] = [p];
            }
          }
        });
      });

      setAffiliateProducts(new_values);
    } catch (e) {}
  };

  useEffect(() => {
    fetchAffiliateProducts();
  }, []);

  useMemo(() => {
    let new_values: { [key: string]: TTMenu[] } = {};
    menus.forEach(m => {
      if (
        isMenuAvailable(m.hours ?? []) &&
        (qr !== null
          ? qr_code_menu_ids[qr]?.length === 0 ||
            qr_code_menu_ids[qr]?.includes(m?.id)
          : true)
      ) {
        new_values[m.business_type ?? 'food_beverage'] = new_values[
          m.business_type
        ]?.concat([m]) ?? [m];
      }
    });
    setCategorizedView(new_values);
  }, [menus]);

  return (
    <>
      <div className="my-4 md:mx-4 ">
        <div className="sticky top-0 z-10 bg-surface">
          <div
            className={`flex flex-no-wrap  overflow-x-auto items-center pl-4 pr-4 scrolling-touch mb-2 mt-2   z-10 space-x-2 bg-primary/10 md:rounded-md`}
            onScroll={() => {}}
          >
            {Object.keys(categorizedView)?.map(category => {
              return (
                <a key={category} href={`#${category}`} className="py-4">
                  <div
                    className={` ${'bg-secondary-container'}  text-on-secondary-container
                 text-center align-center text-sm px-4 content-center items-center py-1 rounded-full w-full h-8 shadow-md outline-none focus:outline-none hover:brightness-150`}
                  >
                    <span className="align-middle truncate font-semibold text-on-secondary-container">
                      {BUSINESS_TYPES_DICT[category]}
                    </span>
                  </div>
                </a>
              );
            })}
            {Object.keys(affiliateProducts)?.map(tag => {
              return (
                <a key={tag} href={`#${tag}`} className="py-4">
                  <div
                    className={` ${'bg-secondary-container'}  'text-on-secondary-container'
                 text-center align-center text-sm px-4 content-center items-center py-1 rounded-full w-full h-8 shadow-md outline-none focus:outline-none  hover:brightness-150`}
                  >
                    <span className="align-middle truncate font-semibold text-on-secondary-container">
                      {toSentenceCase(tag)}
                    </span>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
        {/* <div className="flex flex-nowrap bg-gray-300 overflow-x-scroll items-center px-4 py-2 space-x-2">
          
        </div> */}
        <div className="flex flex-col  px-4 my-2">
          {Object.keys(categorizedView)?.map(c => {
            return (
              <div key={c} className="overflow-x-auto" id={c}>
                <div className="flex flex-row bg-inverse-surface text-inverse-on-surface font-semibold px-2  overflow-x-auto items-center rounded-md py-2">
                  {BUSINESS_TYPES_DICT[c]}
                </div>
                <div className="flex flex-row overflow-x-auto space-x-2 my-2 pb-4">
                  {categorizedView[c]
                    ?.filter(
                      m =>
                        isMenuAvailable(m.hours ?? []) &&
                        (qr !== null
                          ? qr_code_menu_ids[qr]?.length === 0 ||
                            qr_code_menu_ids[qr]?.includes(m?.id)
                          : true),
                    )
                    ?.map(m => {
                      return (
                        <MenuCard
                          menu={m}
                          onClick={() => {
                            logEvent(getAnalytics(), 'menu_clicked', {
                              menu_id: m.id,
                              menu_name: m.name,
                              rank: m.rank,
                            });
                            trackFBEvent(
                              'CatalogClick',
                              {
                                content_ids: [`ctlg_${m.id}`],
                                content_type: 'product_group',
                                content_name: [m.name],
                                content_category: m.business_type,
                              },
                              true,
                              [m.restaurant_id],
                            );
                            trackGAEvent(
                              'select_content',
                              {
                                content_type: 'catalog',
                                content_id: `ctlg_${m.id}`,
                              },
                              [m.restaurant_id],
                            );
                            if (m.affiliate_link_mode && m.affiliate_link) {
                              const trackingUrl = `${menuUrl}/api/v1/affiliate-products/click?is_catalog=true&catalog_id=${
                                m?.id
                              }&merchant_id=${
                                m.restaurant_id
                              }&utm_campaign=${'affiliate_marketing'}&utm_medium=${'affiliate_product_card'}&utm_source=${'TT_GUEST_APP'}`;

                              // Using window.location.href to follow the redirect naturally
                              window.open(trackingUrl, '_blank');
                            } else {
                              dispatch(setMenu(m));
                              navigate(
                                `/feed/restaurants/${r_id}/menus/${m.id}/`,
                              );
                            }
                          }}
                          key={m?.id?.toString()}
                          card_width="w-32"
                        />
                      );
                    })}
                </div>
              </div>
            );
          })}
          {Object.keys(affiliateProducts).map(k => {
            return (
              <div key={k} className="overflow-x-auto" id={k}>
                <div className="flex flex-row bg-inverse-surface text-inverse-on-surface font-semibold px-2  overflow-x-auto items-center rounded-md py-2">
                  {toSentenceCase(k)}
                </div>
                <div className="flex flex-row overflow-x-auto space-x-2 my-2 pb-4">
                  {affiliateProducts[k]?.map(p => {
                    return (
                      <AffiliateProductCard
                        product={p}
                        display_partner_id={parseInt(r_id)}
                        key={`product_${p?.unique_id}`}
                        card_width="w-40"
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
